export const Team__Wolfpack = {
  name: "Wolfpack",
  logoImage: null,
  teamImage: null,
  teamLogoColor: "#c84d4dff",
  teamJerseyColor: "#BD3737",
  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 39 + 26 + 46,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 50 + 46 + 54,
    },
  ],
};
